<template>
  <table class="h-table account-history">
    <thead>
      <tr>
        <th
          v-for="column in columns"
          :key="column.id"
          class="h-table__col-title"
          :class="{
            [column.className]: true,
            active: sortBy === column.sort,
          }"
          @click="sort(column.sort)"
        >
          {{ column.title }}
        </th>
      </tr>
    </thead>

    <template v-for="date in dates">
      <!-- Общая информация за дату -->
      <template v-if="date.resume">
        <tr
          :key="'operations-date-' + date.unique"
          class="h-table__row operations-date"
          :class="{
            'h-table__row--header': date.open,
            'operations-date--open': date.open,
          }"
        >
          <cell
            v-for="column in columns"
            :key="column.id"
            :column="column"
            :date="date"
            :edit="edit"
            :toggler="true"
            @toggle="date.open = !date.open"
          />
        </tr>
      </template>

      <!-- Список операций -->
      <transition :key="`operations-${date.unique}`" name="slide">
        <tbody v-if="!date.resume || date.open" class="slide-transition">
          <tr
            v-for="operation in date.operations"
            :key="operation.unique"
            class="h-table__row"
            :class="{
              'h-table__row--header': date.resume && date.open,
            }"
          >
            <cell
              v-for="column in columns"
              :key="column.id"
              :column="column"
              :date="date"
              :operation="operation"
              :edit="edit"
              :can-remove="canRemove"
              @remove="remove(operation)"
              @restore="restore(operation)"
            />
          </tr>
        </tbody>
      </transition>
    </template>
  </table>
</template>

<script>
import Cell from "./cell";

export default {
  components: { Cell },
  props: ["columns", "dates", "sortBy", "edit", "canRemove"],
  methods: {
    sort(column) {
      console.log('sort', column)
      if (!column) return;
      this.$emit("sort", column);
    },
    remove(transaction) {
      this.$emit("remove", transaction);
    },
    restore(transaction) {
      this.$emit("restore", transaction);
    },
  },
};
</script>

<style lang="scss" scoped>
.account-history {
  & /deep/ tr.collapsing {
    transition: font 0.5s ease;
  }

  thead th {
    text-align: left !important;
    vertical-align: top;
  }
}
</style>
